import { useSelector } from "react-redux";
import { ContactUsFormValues } from "../interfaces/ContactUsFormValues";
import { StoreState } from "../interfaces/storeState";

export const useContactFormValues = (): ContactUsFormValues =>
  useSelector(getContactFormValues);

const getContactFormValues = (state: StoreState): ContactUsFormValues => {
  if (!state.contactUsFormValues) {
    return undefined;
  }

  return state.contactUsFormValues;
};
